import script from "./SalaryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryDetails.vue?vue&type=script&setup=true&lang=js"

import "./SalaryDetails.vue?vue&type=style&index=0&id=1c4d2a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4d2a8e"]])

export default __exports__